const accordion = (() => {
    const elements = document.querySelectorAll('[data-accordion]');
    let counter = 0;

    /**
     * @function init
     * @desc init functions & events
     */
    const init = () => {
        for (let i = 0; i < elements.length; i++) {
            initEvents(elements[i]);
        }
    };

    /**
     * @function initEvents
     * @desc
     */
    const initEvents = (element) => {
        const triggers = element.querySelectorAll('[data-item-trigger]');

        for (let i = 0; i < triggers.length; i++) {
            triggers[i].addEventListener('click', onClickTrigger);
            setAria(triggers[i], i);
        }
        counter++;
    };

    /**
     * @function setAria
     * @desc set WCAG
     */
    function setAria(element, tempCounter) {
        let item = element.parentNode;
        let content = item.querySelector("[data-item-content]");
        element.setAttribute( 'aria-expanded', (item.classList).contains("expanded") );
        element.setAttribute( 'id', "accordion-"+counter+"_trigger-"+tempCounter );
        element.setAttribute( 'aria-controls', "accordion-"+counter+"_content-"+tempCounter );
        content.setAttribute( 'aria-labelledby', "accordion-"+counter+"_trigger-"+tempCounter );
        content.setAttribute( 'id', "accordion-"+counter+"_content-"+tempCounter );
    }

    /**
     * @function open
     * @desc manage accordion opening and closing
     */
    const onClickTrigger = (event) => {
        event.preventDefault();
        let element = event.currentTarget;
        let parent = element.parentNode;
        let status = element.getAttribute('aria-expanded') === 'true';

        let allTriggers = parent.querySelectorAll("[data-item-trigger]");
        allTriggers.forEach(function (el) {
            el.setAttribute('aria-expanded', !status);
        });

        parent.classList.toggle("expanded");
    };

    return {
        init: init
    };
})();

export {accordion}